import { styled } from 'linaria/react';

export const InputContainerRow = styled.div<{ direction?: string }>`
  @media (--from-tablet) {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;
    width: 100%;
  }
  @media (--only-mobile) {
    display: flex;
    flex-direction: ${props => (props?.direction === 'row' ? 'row' : 'column')};
    gap: var(--space-200);
    width: 100%;
  }
`;

export const InputContainerColumn = styled.div<{ last?: boolean }>`
  @media (--from-tablet) {
    display: flex;
    flex-direction: column;
    flex-basis: 48.5%;
    width: 100%;
    margin-bottom: ${props => (props.last ? '0px' : 'var(--space-350)')};
  }
  @media (--only-mobile) {
    flex-basis: 100%;
    margin-bottom: 0px;

    &:last-of-type {
      margin-top: var(--space-100);
    }
  }
`;

export const InputContainerRowDoorsWindows = styled.div<{ direction?: string }>`
  @media (--from-tablet) {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;
    width: 100%;
  }
  @media (--only-mobile) {
    display: flex;
    flex-direction: ${props => (props?.direction === 'row' ? 'row' : 'column')};
    gap: var(--space-200);
    width: 100%;
  }
`;

export const InputContainerColumnDoorsWindows = styled.div<{ last?: boolean }>`
  @media (--from-tablet) {
    display: flex;
    flex-direction: column;
    flex-basis: 48.5%;
    width: 100%;
    margin-bottom: ${props => (props.last ? '0px' : 'var(--space-350)')};
  }
  @media (--only-mobile) {
    flex-basis: 100%;
    margin-bottom: 0px;
  }
`;
